export const ProfileActionsTypes = {
  UPDATE_PROFILE: "UPDATE_PROFILE",
  UPDATE_IMAGE_PROFILE: "UPDATE_IMAGE_PROFILE",
  SET_LOAD_STORE: "SET_LOAD_REDUX",
  DELETE_IMAGE_PROFILE: "DELETE_IMAGE_PROFILE",
  UPDATE_CHECK_THEME: "UPDATE_CHECK_THEME",
};
